import { contains, } from 'ramda';

export { default as getCard, } from './cardsDictionary';
export const isAce = (cardName) => contains(cardName, [ 'Ac', 'Ad', 'Ah', 'As', ]);
